<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 家族ユーザーの予約可能日
      span.validation-label 必須

    .register-value.available-date-radios
      label.register-radio-label
        input#type-0.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="家族ユーザーの予約可能日")
        span.register-radio-text 当日可
      label.register-radio-label
        input#type-1.register-radio-form(v-model="_value" :name="name" type="radio" :value="1")
        span.register-radio-text 前日まで
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" :name="name" type="radio" :value="3")
        span.register-radio-text 3日前まで
      label.register-radio-label
        input#type-3.register-radio-form(v-model="_value" :name="name" type="radio" :value="5")
        span.register-radio-text 5日前まで
      label.register-radio-label
        input#type-4.register-radio-form(v-model="_value" :name="name" type="radio" :value="7")
        span.register-radio-text 1週間前まで

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 何日まで予約できるかの入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputAvailableDate extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  @Prop({ default: "available-date" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.available-date-radios {
  flex-wrap: wrap;
}
</style>
